var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "content-processos" }, [
      _c(
        "div",
        { staticClass: "processos-main" },
        [
          _c(
            "el-card",
            { staticClass: "card-container", attrs: { shadow: "hover" } },
            [
              _c("b", [_vm._v("Solicitar abertura de processo físico:")]),
              _c(
                "div",
                { staticClass: "dados-processo" },
                [
                  _c(
                    "validation-observer",
                    {
                      ref: "validation",
                      staticClass: "align",
                      attrs: { tag: "form" }
                    },
                    [
                      _c(
                        "el-col",
                        { staticStyle: { flex: "1" }, attrs: { span: 8 } },
                        [
                          _c("validation-provider", {
                            attrs: {
                              rules: "required",
                              name: "Tipo de cadastro"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(ref) {
                                  var errors = ref.errors
                                  return [
                                    _c("app-label", {
                                      attrs: {
                                        label: "Selecione o tipo de processo:"
                                      }
                                    }),
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          clearable: "clearable",
                                          filterable: "filterable",
                                          name: "tipo cadastro",
                                          "collapse-tags": "collapse-tags"
                                        },
                                        model: {
                                          value: _vm.tipoCadastro,
                                          callback: function($$v) {
                                            _vm.tipoCadastro = $$v
                                          },
                                          expression: "tipoCadastro"
                                        }
                                      },
                                      _vm._l(_vm.tiposCadastros, function(
                                        item
                                      ) {
                                        return _c("el-option", {
                                          key: item.key,
                                          attrs: {
                                            label: item.name,
                                            value: item.value
                                          }
                                        })
                                      }),
                                      1
                                    ),
                                    _c("span", { staticClass: "help erro" }, [
                                      _vm._v(_vm._s(errors[0]))
                                    ])
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { staticStyle: { flex: "1" }, attrs: { span: 8 } },
                        [
                          _c("validation-provider", {
                            ref: "provider",
                            attrs: {
                              rules: "required",
                              name: "Número Processo"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(ref) {
                                  var errors = ref.errors
                                  return [
                                    _c(
                                      "div",
                                      { staticStyle: { display: "flex" } },
                                      [
                                        _c("app-label", {
                                          attrs: {
                                            label:
                                              "Insira o número do processo:",
                                            required: "required"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c("el-input", {
                                      staticClass: "input",
                                      class: { erro: errors.length },
                                      attrs: { name: "Número Processo" },
                                      on: { input: _vm.validateInput },
                                      model: {
                                        value: _vm.numeroProcesso,
                                        callback: function($$v) {
                                          _vm.numeroProcesso = $$v
                                        },
                                        expression: "numeroProcesso"
                                      }
                                    }),
                                    _c("span", { staticClass: "help erro" }, [
                                      _vm._v(_vm._s(errors[0]))
                                    ])
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("app-buttons-cadastro", {
                staticClass: "alinhar",
                attrs: { showButtonProximo: true, isPrimeiroPasso: true },
                on: {
                  cancelar: function($event) {
                    return _vm.cancelar()
                  },
                  proximo: function($event) {
                    return _vm.proximo()
                  }
                }
              })
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e934955", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e934955","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/processoFisico/EscolhaTipoProcessoFisico.vue
// module id = null
// module chunks = 